<template>
  <div>
  <b-container>
    <NavBar></NavBar>
    <b-row>
      <b-col><br></b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="auto">
        <param-box :options_sel="option_reg" :date-from="dateFrom" :date-to="dateTo" @update-data="onUpdateData"></param-box>
      </b-col>
      <b-col>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Сводная статистика" active>
              <b-row>
                <b-col>
                  <doughnut-region :capt="capt_reg" :chartdata="data_reg" :chartlabels="labels_reg">
                  </doughnut-region>
                </b-col>
                <b-col>
                  <doughnut-cases v-model="data_grp" :capt="capt_reg" :chartdata="data_grp" :chartlabels="labels_grp"></doughnut-cases>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <!--<b-button @click.native="showModalLegend($event.target)">Развернуть</b-button>-->
                  <!--<legend-table :items="legendItems"></legend-table>-->
                  <button type="button" class="btn btn-primary"
    v-on:click="showModalLegend($event.target)">Расшифровка
    </button>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Детализация" >
              <client-table :items="clientsList" ></client-table>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
    <!-- Info modal -->
    <b-modal size="lg" id="modalLegend"  :title="modalLegend.title" ok-only>
      <div>
        <legend-table striped
         small
         hover
         :items="modalLegend.items"
         :byCat="catByReg"></legend-table>
          <!--<b-pagination :total-rows="modalInfo.totalRows" :per-page="modalInfo.perPage" v-model="modalInfo.currentPage" class="my-0" />-->
      </div>
    </b-modal>
  </div>
</template>

<script>

import 'bootstrap/dist/css/bootstrap.css'
// import DoughnutChart from '@/component/DoughnutChart'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import NavBar from '../components/NavBar'
import ParamBox from '../components/ParamBox'
import ClientTable from '../components/ClientTable'
import DoughnutRegion from '../components/DoughnutRegion'
import DoughnutCases from '../components/DoughnutCases'
import LegendTable from '@/components/LegendTable'
import axios from 'axios'
// import moment from 'moment'
// import moment from 'moment'
// Vue.use(datePicker)
let regToRegSel = (array) =>
  array.reduce((obj, item, i) => {
    let _s = item[1].replace('Ленинградская обл ', '')
    obj[i] = {'text': _s, 'value': [item[0], _s]}
    return obj
  }, [])

let reqPath = process.env.VUE_APP_RECORD_REQ_URL // 'http://localhost:5000' 'https://stat.zabota365.ru'
export default {
  name: 'Stat',
  data () {
    return {
      catByReg: [],
      regionsId: [],
      data_reg: [],
      labels_reg: [],
      selReg: [],
      data_grp: [],
      labels_grp: [],
      capt_reg: 'test',
      dateTo: new Date().toLocaleDateString('ru-RU').substr(0, 10),
      dateFrom: new Date().toLocaleDateString('ru-RU').substr(0, 10),
      clientsList: [],
      option_reg: [],
      legendItems: [],
      modalLegend: {
        title: 'Сводная таблица',
        items: [],
        byCat: []
      }
      // dateCurrent: new Date(),
    }
  },
  components: {
    LegendTable,
    DoughnutCases,
    DoughnutRegion,
    ClientTable,
    ParamBox,
    NavBar
  },
  created () {
    //
  },
  mounted () {
    this.dateFrom = new Date().toLocaleDateString('ru-RU').substr(0, 10)
    this.dateTo = this.dateFrom
    this.getRegions()

    // change this to get from server
    if (localStorage.getItem('labelsRegs')) {
      this.labels_reg = JSON.parse(localStorage.getItem('labelsRegs'))
    }
    if (localStorage.getItem('clientsList')) {
      this.clientsList = JSON.parse(localStorage.getItem('clientsList'))
    }
    if (localStorage.getItem('dataRegs')) {
      this.data_reg = JSON.parse(localStorage.getItem('dataRegs'))
    }
    if (localStorage.getItem('dataGrp')) {
      this.data_grp = JSON.parse(localStorage.getItem('dataGrp'))
    }
    if (localStorage.getItem('regs_id')) {
      this.regionsId = JSON.parse(localStorage.getItem('regs_id'))
    }
    if (localStorage.getItem('selRegs')) {
      this.selReg = JSON.parse(localStorage.getItem('selRegs'))
    }
    if (localStorage.getItem('dateFrom')) {
      this.dateFrom = localStorage.getItem('dateFrom')
    } else {
      localStorage.setItem('dateFrom', this.dateFrom)
    }
    if (localStorage.getItem('dateTo')) {
      this.dateTo = localStorage.getItem('dateTo')
    } else {
      localStorage.setItem('dateTo', this.dateTo)
    }
    if (localStorage.getItem('catByReg')) {
      this.catByReg = localStorage.getItem('catByReg')
    } else {
      localStorage.setItem('catByReg', this.catByReg)
    }
  },
  methods: {
    onUpdateData (value) {
      // this.data_reg = [].map.call(value[2], (obj) => { return obj[0] })
      this.selReg = [].map.call(value[2], (obj) => { return obj[0] })
      this.labels_reg = [].map.call(value[2], (obj) => { return obj[1] })
      this.capt_reg = 'sss'
      this.dateFrom = localStorage.getItem('dateFrom') // value[0]
      this.dateTo = localStorage.getItem('dateTo') // value[1]
      localStorage.setItem('labelsRegs', JSON.stringify(this.labels_reg))
      localStorage.setItem('selRegs', JSON.stringify(this.selReg))
      this.getStaticData()
      this.getGroupData()
      this.getClientData()
      this.getCatExtR()
    },
    getRegions () {
      this.getRegionsHttp()
      this.getCategoriesHttp()
      this.getStaticData()
      this.getGroupData()
      this.getCatExtR()
      // localStorage.setItem('labelsRegs', JSON.stringify(labelsReg))
      // localStorage.setItem('dataRegs', JSON.stringify(dataReg))
    },
    getRegionsHttp () {
      let path = reqPath + '/api/lenobl/v.1/getregions'
      axios.get(path)
        .then(response => {
          // console.log(response.data)
          // console.log(regToRegSel(response.data))
          localStorage.setItem('option_reg', JSON.stringify(regToRegSel(response.data)))
          this.option_reg = regToRegSel(response.data)
          return 0// regToRegSel(response.data)
          // this.randomNumber = response.data.randomNumber
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCategoriesHttp () {
      let path = reqPath + '/api/lenobl/v.1/getcategories'
      console.log(path)
      axios.get(path)
        .then(response => {
          console.log(response.data)
          localStorage.setItem('labels_grp', JSON.stringify([].map.call(response.data, (obj) => { return obj[1] })))
          this.labels_grp = [].map.call(response.data, (obj) => { return obj[1] })
          // this.randomNumber = response.data.randomNumber
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStaticData () {
      let path = reqPath + '/api/lenobl/v.1/getStatisticsReg'
      console.log(path)
      if (this.dateFrom === '') {
        this.dateFrom = new Date().toLocaleDateString('ru-RU').substr(0, 10)
        this.dateTo = this.dateFrom
      }
      axios.post(path, {
        datefrom: this.dateFrom,
        dateto: this.dateTo,
        regs: this.selReg
      })
        .then(response => {
          // console.log()
          this.data_reg = [].map.call(response.data, (obj) => { return obj[1] })
          localStorage.setItem('dataRegs', JSON.stringify(this.data_reg))
          // this.randomNumber = response.data.randomNumber
        })
        .catch(error => {
          console.log(error)
        })
      //
    },
    getGroupData () {
      let path = reqPath + '/api/lenobl/v.1/getStatisticsCat'
      // console.log(path)
      if (this.dateFrom === '') {
        this.dateFrom = new Date().toLocaleDateString('ru-RU').substr(0, 10)
        this.dateTo = this.dateFrom
      }
      axios.post(path, {
        datefrom: this.dateFrom,
        dateto: this.dateTo,
        regs: this.selReg
      })
        .then(response => {
          console.log('Begin getStatisticsCat')
          console.log(response.data)
          console.log('End getStatisticsCat')
          this.data_grp = [].map.call(response.data, (obj) => { return obj[1] })
          localStorage.setItem('dataGrp', JSON.stringify(this.data_grp))
          this.labels_grp = [].map.call(response.data, (obj) => { return obj[0] })
          localStorage.setItem('labels_grp', JSON.stringify(this.labels_grp)) // this.randomNumber = response.data.randomNumber
        })
        .catch(error => {
          console.log(error)
          console.log(path)
        })
      //
    },
    getClientData () {
      let path = reqPath + '/api/lenobl/v.1/getClientList'
      axios.post(path, {
        datefrom: this.dateFrom,
        dateto: this.dateTo,
        regs: this.selReg
      })
        .then(response => {
          console.log(response.data)
          this.clientsList = [].map.call(response.data, (obj) => { return { 'reg_name': obj[3], 'full_name': obj[4], 'count_case': obj[5], 'reg_id': obj[0], 'client_id': obj[2] } })
          localStorage.setItem('clientsList', JSON.stringify(this.clientsList))
          // this.data_grp = [].map.call(response.data, (obj) => { return obj[1] })
          // this.randomNumber = response.data.randomNumber
        })
        .catch(error => {
          console.log(error)
        })
      //
    },
    showModalLegend (button) {
      this.getCatExt()
      this.$root.$emit('bv::show::modal', 'modalLegend', button)
    },
    getCatExt () {
      let path = reqPath + '/api/lenobl/v.1/getCatExt'
      axios.post(path, {
        datefrom: this.dateFrom,
        dateto: this.dateTo,
        regs: this.selReg
      })
        .then(response => {
          console.log(response.data)

          this.modalLegend.items = [].map.call(response.data, (obj) => {
            return {
              'reg_name': obj[0],
              'c1': obj[1],
              'c2': obj[2],
              'c3': obj[3],
              'c4': obj[4],
              'c5': obj[5],
              'c6': obj[6],
              'c7': obj[7],
              'c8': obj[8],
              'c9': obj[9],
              'c10': obj[10],
              'c11': obj[11],
              'c12': obj[12],
              'c13': (obj[1] + obj[2] + obj[3] + obj[4] + obj[5] + obj[6] + obj[7] + obj[8] + obj[9] + obj[10] + obj[11] + obj[12])
            }
          })
          // Add summary row to legend table, need to make this beautify
          let _tsum = {'reg_name': 'Итого',
            'c1': 0,
            'c2': 0,
            'c3': 0,
            'c4': 0,
            'c5': 0,
            'c6': 0,
            'c7': 0,
            'c8': 0,
            'c9': 0,
            'c10': 0,
            'c11': 0,
            'c12': 0,
            'c13': 0}
          this.modalLegend.items.forEach((value) => {
            console.log('Legeng summary')
            console.log(value.c1)
            _tsum.c1 += value.c1
            _tsum.c2 += value.c2
            _tsum.c3 += value.c3
            _tsum.c4 += value.c4
            _tsum.c5 += value.c5
            _tsum.c6 += value.c6
            _tsum.c7 += value.c7
            _tsum.c8 += value.c8
            _tsum.c9 += value.c9
            _tsum.c10 += value.c10
            _tsum.c11 += value.c11
            _tsum.c12 += value.c12
            _tsum.c13 += value.c13
          })
          this.modalLegend.items.push(_tsum)
          localStorage.setItem('catext', JSON.stringify(this.modalLegend.items))
          // this.data_grp = [].map.call(response.data, (obj) => { return obj[1] })
          // this.randomNumber = response.data.randomNumber
        })
        .catch(error => {
          console.log(error)
        })
      //
    },
    getCatExtR () {
      let path = reqPath + '/api/lenobl/v.1/getCatSumR'
      axios.post(path, {
        datefrom: this.dateFrom,
        dateto: this.dateTo,
        regs: this.selReg
      })
        .then(response => {
          this.catByReg = [].map.call(response.data, (obj) => {
            return {
              'reg_name': obj[0],
              'c1': obj[1],
              'c2': obj[2],
              'c3': obj[3]
            }
          })
          // Add summary row to legend table, need to make this beautify
          let _tsum = {'reg_name': 'Итого',
            'c1': 0,
            'c2': 0,
            'c3': 0
          }
          this.catByReg.forEach((value) => {
            _tsum.c1 += value.c1
            _tsum.c2 += value.c2
            _tsum.c3 += value.c3
          })
          this.catByReg.push(_tsum)
          console.log('Category by reg')
          console.log(this.catByReg)
          localStorage.setItem('catByReg', JSON.stringify(this.catByReg))
          // this.data_grp = [].map.call(response.data, (obj) => { return obj[1] })
          // this.randomNumber = response.data.randomNumber
        })
        .catch(error => {
          console.log(error)
        })
      //
    }
  }
}
</script>

<style>
.modal.show .modal-dialog {
  max-width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/views/Stat.vue